import { Route } from 'types/route.type';

import { routes as mySupplyPlan } from './features/my-supply-plan/routes';
import { routes as orderDistribution } from './features/order-distribution/routes';
import { routes as orderHistory } from './features/order-history/routes';
import { routes as purchaseHistory } from './features/purchase-history/routes';

export const routes: Route[] = [...mySupplyPlan, ...orderDistribution, ...orderHistory, ...purchaseHistory];
